import { Box } from "@mui/material";
import { keyframes, styled } from "@mui/material/styles";
import React from "react";
interface LoaderUpscaleProps {
  cardSize: number;
  backgroundImage?: string;
}

const growSquareAnimation = keyframes({
  "0%": {
    width: "50%",
    height: "50%",
    borderTopLeftRadius:
      "var(--animation-loader_upscale-frame-border-radius-small)",
    borderTopRightRadius:
      "var(--animation-loader_upscale-frame-border-radius-small)",
    borderBottomLeftRadius:
      "var(--animation-loader_upscale-frame-border-radius-normal)",
    borderBottomRightRadius:
      "var(--animation-loader_upscale-frame-border-radius-small)",
  },
  "100%": {
    width: "100%",
    height: "100%",
    borderRadius: "var(--animation-loader_upscale-frame-border-radius-normal)",
  },
});

const blurImageAnimation = keyframes({
  "0%": {
    filter: "blur(var(--animation-loader_upscale-blur-size)) brightness(0.5)",
  },
  "100%": {
    filter: "blur(0px)",
  },
});

const Container = styled(Box, {
  shouldForwardProp: (prop) => prop !== "cardSize",
})<LoaderUpscaleProps>(({ cardSize }) => ({
  "--animation-loader_upscale-frame-border-radius-normal": `${cardSize * 0.05}px`,
  "--animation-loader_upscale-frame-border-radius-small": `${cardSize * 0.02}px`,
  "--animation-loader_upscale-blur-size": `${cardSize * 0.003}px`,
  position: "relative",
  width: `${cardSize / 4}px`,
  height: `${cardSize / 4}px`,
}));

const Frame = styled(Box, {
  shouldForwardProp: (prop) => prop !== "cardSize",
})<LoaderUpscaleProps>(({ cardSize }) => ({
  position: "absolute",
  width: "100%",
  height: "100%",
  border: `${cardSize * 0.01}px dashed white`,
  borderRadius: `${cardSize * 0.05}px`,
  overflow: "hidden",
}));

const GrowingSquare = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== "cardSize" && prop !== "backgroundImage",
})<LoaderUpscaleProps>(({ backgroundImage, cardSize }) => ({
  position: "absolute",
  bottom: 0,
  left: 0,
  width: "0%",
  height: "0%",
  backgroundColor: "#191A23",
  backgroundImage: `url(${backgroundImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  overflow: "hidden",
  animation: `${growSquareAnimation} 2s cubic-bezier(1,0,0,1) infinite alternate`,
  borderWidth: `${cardSize * 0.01}px`,
}));

const ImageBlur = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== "cardSize" && prop !== "backgroundImage",
})<LoaderUpscaleProps>(({ backgroundImage }) => ({
  width: "100%",
  height: "100%",
  backgroundImage: `url(${backgroundImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  animation: `${blurImageAnimation} 2s cubic-bezier(1,0,0,1) infinite alternate`,
}));

export const LoaderUpscale: React.FC<LoaderUpscaleProps> = ({
  cardSize,
  backgroundImage,
}) => {
  return (
    <Container cardSize={cardSize}>
      <Frame cardSize={cardSize} />
      <GrowingSquare cardSize={cardSize} backgroundImage={backgroundImage}>
        <ImageBlur cardSize={cardSize} backgroundImage={backgroundImage} />
      </GrowingSquare>
    </Container>
  );
};
